import React from "react";
import { Badge } from "react-bootstrap";
import { CommonModal } from "../Input";
import DataTable from "../table/DataTable";

const CashierDetailsModal = ({ show, onHide, cashier }) => {
  if (!cashier) return null;

  const columns = [
    {
      label: "IMAGE",
      key: "image",
      className: "ps-4",
      cellClassName: "ps-4",
      style: { width: "100px" },
      render: (item) => (
        <div
          className="d-flex align-items-center justify-content-center border rounded bg-white overflow-hidden"
          style={{ width: "45px", height: "30px", borderColor: "#eee" }}
        >
          {item.image ? (
            <img
              src={item.image}
              alt={item.label}
              style={{ width: "100%", height: "auto" }}
            />
          ) : (
            <div className="text-muted fs-8 fw-bold">$$</div>
          )}
        </div>
      ),
    },
    {
      label: "DENOMINATION",
      key: "label",
      style: { width: "250px" },
      render: (item) => (
        <span className="fs-13 fw-bold text-black">{item.label}</span>
      ),
    },
    {
      label: "INVENTORY",
      key: "inventory",
      className: "text-center",
      cellClassName: "text-center",
      style: { width: "150px" },
      render: (item) => (
        <div className="d-flex align-items-center justify-content-center">
          {item.inventory !== "-" && (
            <div
              className="rounded-circle me-1"
              style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#34D399",
              }}
            />
          )}
          {item.inventory !== "-" ? (
            <span className="fw-bold fs-12 text-black">{item.inventory}</span>
          ) : (
            <span className="text-muted">—</span>
          )}
        </div>
      ),
    },
    {
      label: "TOTAL",
      key: "total",
      className: "pe-4 text-end",
      cellClassName: "pe-4 text-end",
      style: { width: "180px" },
      render: (item) => (
        <span className="fw-bold fs-13 text-black">{item.total}</span>
      ),
    },
  ];

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      title={cashier.drawerId}
      size="xl"
      fullscreen={false}
      scrollable={true}
      headerClassName="px-4 py-3"
      footerClassName="d-none" // Hide default footer if any
    >
      <div
        className="px-4 pt-4 pb-2"
        style={{ backgroundColor: "#FAFAFA", borderRadius: "12px" }}
      >
        {/* USD Table */}
        <div className="card shadow-none rounded-4 overflow-hidden border border-light mb-0 bg-white">
          <DataTable
            columns={columns}
            data={cashier.usdData || []}
            showPagination={false}
            minWidth="100%"
          />
        </div>

        {/* Total SGD Badge */}
        {cashier.sgdTotal && (
          <div className="d-flex justify-content-end mb-3 mt-3">
            <Badge
              bg="light"
              className="text-black border px-4 py-2 d-flex align-items-center"
              style={{
                borderRadius: "20px",
                fontSize: "13px",
                backgroundColor: "#ffffff",
                borderColor: "#E2E8F0",
              }}
            >
              <span className="text-muted me-2 fw-normal">Total cash:</span>
              <span className="fw-bold" style={{ color: "#1E40AF" }}>
                {cashier.sgdTotal}
              </span>
            </Badge>
          </div>
        )}

        {/* SGD Table */}
        <div className="card shadow-none rounded-4 overflow-hidden border border-light mb-4 bg-white">
          <DataTable
            columns={columns}
            data={cashier.sgdData || []}
            showPagination={false}
            minWidth="100%"
          />
        </div>
      </div>
    </CommonModal>
  );
};

export default CashierDetailsModal;
